
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import ItemsTree from '@/components/IndexTemplates/ItemsTree/ItemsTree.vue'
import { VariableNodeInterface } from '@/models/tree/VariableNode.interface'

export default defineComponent({
  components: {
    ItemsTree
  },
  props: {
    type: { type: String, required: true },
    loading: { type: Boolean, default: false }
  },
  emits: ['paginate'],
  setup() {
    const router = useRouter()
    const itemClickedHandler = (node: VariableNodeInterface) => {
      if (['image'].includes(node.kind)) return

      router.push({
        name: 'show_template',
        params: { slug: node.slug }
      })
    }

    return { itemClickedHandler }
  }
})
